'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e$1 from "../defs/House.es.js";
const e = a.forwardRef((r, s) => /* @__PURE__ */ a.createElement(p, { ref: s, ...r, weights: e$1 }));
e.displayName = "HouseIcon";
const n = e;
export {
  n as House,
  e as HouseIcon
};
